import React, { useContext } from 'react';
import styles from './CaseNumberField.module.scss';
import {
  SFAutocomplete,
  SFAutocompleteProps,
  SFMenuOption,
  SFText
} from 'sfui';

import { IntegrationReportsContext } from '../../../../../Context/IntegrationReportsContext';
import { ReportValue } from '../../../../../Models';
import { formatDate } from '../../../../../Helpers';
import { Customer, CustomerContext } from 'ui-smartforce-settings';

export const CaseNumberField = (
  props: SFAutocompleteProps
): React.ReactElement<SFAutocompleteProps> => {
  const { integrationReports } = useContext(IntegrationReportsContext);
  const customer = useContext(CustomerContext).customer as Customer;

  const getReportDate = (value: string): string => {
    const report: ReportValue = integrationReports.filter(
      (report) => report.general_information.incident_number === value
    )[0];

    return report.general_information.date as string;
  };

  const renderOption = (option: SFMenuOption) => {
    return (
      <div
        className={styles.caseNumberFieldOption}
        style={{
          padding: option.label && option.label.length > 0 ? '6px 24px' : '0'
        }}
      >
        <SFText type="component-1">
          {typeof option === 'string' ? option : option.label}
        </SFText>
        <SFText type="component-3" className={styles.date}>
          {formatDate(
            getReportDate(option.value),
            'MM/DD/YYYY',
            customer.timezone
          )}
        </SFText>
      </div>
    );
  };

  const value: SFMenuOption | string =
    props.options.filter((option) => option.value === props.value)[0] ||
    props.value;

  const onChange = (value: string | SFMenuOption) => {
    props.onChange(value);
  };

  return (
    <SFAutocomplete
      freeSolo
      label={props.label}
      required={props.required}
      helperText={props.helperText}
      error={props.error}
      options={props.options}
      renderOption={renderOption}
      value={value}
      onChange={onChange}
    />
  );
};
